import React, { useRef } from 'react';
import { useMutation } from '@apollo/client';
import ScanLabelMutation from './ScanLabelMutation';

interface IScanLabelConnectorApolloProps {
  children: ({
    scanLabel,
    cancelScanLabel,
  }: {
    scanLabel: (images: File[], userComment?: string) => Promise<unknown>;
    cancelScanLabel: () => void;
  }) => React.ReactElement;
}

const ScanLabelConnectorApollo: React.FC<IScanLabelConnectorApolloProps> = ({ children }) => {
  const [scanLabelMutation] = useMutation(ScanLabelMutation);
  const abortControllerRef = useRef<AbortController | null>(null);

  const scanLabel = async (images: File[], userComment?: string) => {
    abortControllerRef.current = new AbortController();

    const response = await scanLabelMutation({
      variables: { images, userComment },
      context: {
        fetchOptions: {
          signal: abortControllerRef.current.signal,
        },
      },
    });

    return response.data?.dailyTracker?.scanLabel;
  };

  const cancelScanLabel = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };

  return children({ scanLabel, cancelScanLabel });
};

export default ScanLabelConnectorApollo;
